const state = {
  tiposEndereco: [
    { id_tipo_endereco: 1, descricao: 'RESIDENCIAL' },
    { id_tipo_endereco: 2, descricao: 'TRABALHO' },
    { id_tipo_endereco: 3, descricao: 'ENTREGA' },
    { id_tipo_endereco: 4, descricao: 'COBRANCA' },
    { id_tipo_endereco: 5, descricao: 'OUTROS' },
  ]
};

const getters = {
  tiposEndereco: state => state.tiposEndereco,
};

const actions = {};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
}